import { flatten } from 'ramda'

import { BrandFragment } from '@app-graphql/schema'
import { Localization } from '@aa-app-localization'
import { Highlight } from '@app-domains/navigation/category-dropdown/category-dropdown'
import { LocalizedHighlightedItem, LocalizedRouting } from '@app-domains/navigation/types/navigation.types'

export const translateBrands = (
    brand: BrandFragment,
    lang: Localization.Locale,
): LocalizedRouting => {
    const translation = brand.translations[lang]
    return {
        id: brand.id.toString(),
        name: brand.name,
        slug: brand.slug,
        // eslint-disable-next-line max-len
        highlightedItems: translation.highlightedItem?.filter((item): item is NonNullable<typeof item> => !! item) ?? [],
    }
}

export const mapHighlightedItemsToHighlights = (items: LocalizedHighlightedItem[]): Highlight[] => {
    return items.map((item) => ({
        highlight: true,
        image: item.image?.url ?? '',
        title: item.title,
        link: item.link?.link ?? '',
        target: item.link?.target ?? '',
    }))
}

export const randomizeHighlightedItems = (items: LocalizedRouting[]): Highlight[] => {
    const tiles = items.map((b) => b.highlightedItems ?? [])
    const flattened = flatten(tiles) as LocalizedHighlightedItem[]
    const sorted = flattened.sort(() => Math.random() - 0.5).slice(0, 3)
    return mapHighlightedItemsToHighlights(sorted)
}
